import { AcceptSharedPortfolio } from '@unistocks/features/shared-portfolios/accept-shared-portfolio';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function ShareScreen() {
  return (
    <>
      <Head>
        <title>{t('::Portfolio:Share:AcceptShare')}</title>
      </Head>
      <AcceptSharedPortfolio />
    </>
  );
}
